/**
 * Public link a client uses to view a Client Price List and fill in quantities —
 * no login required, gated by the list's secret token (`?t=`), not the list id
 * alone (D116.1, bug #33; see the /respond/:id route and the respond/getById
 * handlers in clientPriceList.controller.js). The token comes from the staff
 * `/details` read (`ClientPriceList.accessToken`), never from a list row.
 *
 * Single source of truth for building this link: used by both "Copy Client Link"
 * and the default email template, so there is only one place that knows the URL shape.
 */
export function getClientPriceListPublicLink(listId: string, token: string): string {
  return `${window.location.origin}/respond/${listId}?t=${encodeURIComponent(token)}`;
}
